import { Component, Input } from '@angular/core';
import { ImageCdnSrcDirective } from '@polaris-customerweb/sharedcomponents.shared';

@Component({
    imports: [ImageCdnSrcDirective],
    selector: 'rdx-snow-trail-list',
    standalone: true,
    styleUrls: ['./snow-trail-list.component.scss'],
    templateUrl: './snow-trail-list.component.html',
})
export class SnowTrailListComponent {
    @Input() isShowingSatellite = false;
}
